import React from "react";
import PropTypes from "prop-types";

function PromoCompanyResult({ gid }) {
  return <div>PromoCompany: {JSON.stringify(gid)}</div>;
}

PromoCompanyResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default PromoCompanyResult;
